import React from 'react';
import { cn } from '@/lib/utils';

export interface FilterItem {
    id: string;
    label: string;
    total?: number;
}

interface StatusFilterProps {
    items: FilterItem[];
    value?: string;
    classStyle?: string;
    disabled?: boolean;
    onChange: (value: string) => void;
}

const StatusFilter = ({ items, value, onChange, classStyle, disabled }: StatusFilterProps) => {
    return (
        <>
            {items.map((item) => {
                const active = value === item.id;

                return (
                    <button
                        type="button"
                        key={item.id}
                        disabled={disabled}
                        onClick={() => onChange(item.id)}
                        className={cn(
                            'p-3 min-w-[100px] shrink-0 rounded-[12px] border transition-all duration-200 ',
                            disabled ? 'cursor-default opacity-60' : 'cursor-pointer',
                            classStyle,
                            active
                                ? 'bg-text-blue-100 text-white border-text-blue-100 body1bold'
                                : `bg-bg-grey-300  border-bg-grey-300 body1 text-text-grey ${disabled ? '' : 'hover:opacity-70'}`
                        )}
                    >
                        {item.label} {item.total}
                    </button>
                );
            })}
        </>
    );
};

export default StatusFilter;
